import $ from 'jquery';
import Decimal from 'decimal.js';
import { numberWithCommas } from "./custom_format_input_number.js";
import { toHalfWidth } from "./custom_format_input_number.js";
import { setOrderInputFieldValue } from "./custom_format_input_number.js";
import { parseFormattedNumber } from "./custom_format_input_number.js";
import { updateOrderSummary, formatNumberField, updateOrderItemTotalFee } from "./custom_format_input_number.js";

const UNIT_KG = 'kg';
const SCROLL_TOP_AFTER_RELOAD_KEY = 'js_scroll_top_after_reload';

$(document).on('turbolinks:before-cache', function () {
  $('.js-source-products-ajax, .js-orders-source-shops').each(function () {
    if ($(this).hasClass('select2-hidden-accessible')) {
      $(this).select2('destroy');
    }
  });
  $('.modal').modal('hide');
  $(document).off('keydown');
});

$(document).on('turbolinks:load', function () {
  if (sessionStorage.getItem(SCROLL_TOP_AFTER_RELOAD_KEY)) {
    sessionStorage.removeItem(SCROLL_TOP_AFTER_RELOAD_KEY);
    window.scrollTo(0, 0);
  }

  let isAddOneItemClicked = false;
  initSelect2ProductsAjax();
  initSelect2ProductsAjax(false, $('.js-source-products-code-ajax'));
  initSelect2ProductsAjax(false, $('.js-source-products-gname-ajax'));
  handleSelectProductAjax();
  handleSelectShopOrder();
  handleFilterDateRaditoChangeState();
  fillProductSelectShopOnOrder();
  setTabIndex();
  resetShopDropdown();

  initSelect2OrderSourceShops();
  // init variable
  let isEditMode = false;

  var current_pathname = location.pathname;
  setTimeout(() => {
    if (current_pathname != "/orders/pick-up" || current_pathname != "/orders/pickup_orders") {
      const $select2Element = $('.js-orders-source-shops');

      if ($select2Element.length) {
        $select2Element.select2('open');

        $select2Element.on('select2:open', function () {
          setTimeout(() => {
            const $searchInput = $('.select2-search__field');
            if ($searchInput.length) {
              $searchInput.trigger('focus');
            }
          }, 100);
        });

        $(document).on('keydown', function (e) {
          const $dropdown = $('.select2-dropdown');

          if ($dropdown.is(':visible')) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
              e.preventDefault();
            }
          }
        });

        $(document).on('keydown', function (e) {
          const $dropdown = $('.select2-dropdown');

          if ($dropdown.is(':visible') && e.key === 'Tab') {
            $select2Element.select2('close');
            e.preventDefault();
          }
        });
      }
    }
  }, 200);

  function trapFocus(modal) {
    const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const $focusableElements = modal.find(focusableSelectors).filter(':visible');
    const firstFocusable = $focusableElements.first()[0];
    const lastFocusable = $focusableElements.last()[0];

    modal.on('keydown', function (e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      }
    });
  }

  function resetSelect2() {
    $('.js-source-products-ajax').each(function () {
      const $select = $(this);
      if ($select.hasClass('select2-hidden-accessible')) {
        $select.select2('destroy');
        $select.select2();
        initSelect2ProductsAjax(false, $select);
      }
    });
  }

  $('.js-add-one-item').on('click', function () {
    isAddOneItemClicked = true;
  });

  $('.js-add-five-item').on('click', function () {
    isAddOneItemClicked = false;
  });

  let isProductSelectFocused = false;
  function focusOnProductSelect(addedItem, isReplaceProduct = false) {
    if (isProductSelectFocused) return;

    let productSelect = addedItem.find('.js-source-products-ajax').first();
    if (isReplaceProduct) {
      productSelect = $('.js-source-products-ajax').filter((_, el) => $(el).closest('.row').is(addedItem)).first();
    }

    if (productSelect.length > 0 && !productSelect.val()) {
      productSelect.select2("open")

      isProductSelectFocused = true;

      setTimeout(() => {
        isProductSelectFocused = false;
      }, 500);
    } else {
      if (isReplaceProduct) {
        focusToFirstAmountField();
      } else {
        const el = addedItem.find('.js-order-item-amount');
        if (el.length > 0) {
          setTimeout(() => {
            $($(el)[0]).focus();
          }, 100);
        }
      }
    }
  }

  // order item sortable
  $(".order-items-sortable").sortable({
    items: ".order-new-item:not(.unsortable)",
    update: function () {
      updateSortIndex();
    }
  });

  $('.js-order-surcharge').on('blur', function () {
    updateOrderSummary(true);
  });

  function updateSortIndex() {
    let items = $(".order-items-sortable .order-new-item:not([style*='display: none'])");

    items.each(function (index) {
      $(this).find('input.js-sort-index-val').val(index + 1);
    });
  }

  $('#order-items-nested-form .content-nested-form')
    .on('cocoon:after-insert', function (e, added_item) {
      added_item.after($('#js-link-to-add-item'));

      initSelect2ProductsAjax(false, added_item.find('.js-source-products-ajax'));
      // initSelect2ProductsAjax();
      handleSelectProductAjax();
      setTimeout(() => focusOnProductSelect(added_item, true), 100);

      let sortable_wrapper = $(added_item).parents('.order-items-sortable');
      let items = sortable_wrapper.find('.order-new-item:not([style*="display: none"])');

      let added_item_index = items.length;
      $(added_item).find('input.js-sort-index-val').val(added_item_index);
    });

  $('#order-items-nested-form .content-nested-form')
    .on('cocoon:after-remove', function (e, removed_item) {
      updateOrderSummary();
    });

  $(document).on('shown.bs.modal', '#js-order-producing-modal', function () {
    handleSelectDirectiveTypeProduceOrder($('#js-order-producing-modal'));
  });

  $(document).on('shown.bs.modal', '#createNewProduceOrderModal', function () {
    $('.js-source-doughs').select2({
      dropdownParent: $('#createNewProduceOrderModal'),
      placeholder: "生地",
      language: { noResults: function () { return "見つかりません"; } }
    });

    $('.js-source-doughs').on('select2:select', function (e) {
      var data = e.params.data;

      $.ajax({
        url: '/manufacturing/products/get_by_dough',
        method: 'GET',
        data: {
          dough_id: data.id,
          'authenticity_token': $('meta[name="csrf-token"]').attr('content')
        }
      }).done(function () {
        handleSelectDirectiveTypeProduceOrder($('#createNewProduceOrderModal'));
      });
    });

    $('.js-source-products-ajax').on('select2:select', function (e) {
      var data = e.params.data;
      let product_unit_type = data.unit_type;

      $('#createNewProduceOrderModal').find('.js-product-unit-type').html(product_unit_type);
    });
  });

  $(document).on('shown.bs.modal', '#addUnexpectedProductsModal', function () {
    initSelect2OrderSourceShops($('.modal.js-order-item-modal'));

    $('.js-orders-source-shops, .js-orders-pick-up-source-shops').on('select2:select', function (e) {
      var data = e.params.data;
      var shop_id = data.id;

      $('.js-add-order-items-btn').removeClass('d-none');

      process_fill_shop_products(shop_id);
    });

    let modalStateVal = '';
    modalStateVal = $('.js-order-item-modal').find('#js_state_add_items').val();
    if (modalStateVal == 'load_page') {
      let shopId = $('input.js-selected-shop-id').val();

      if (shopId == '' || shopId == undefined) {
        shopId = $('select.js-orders-source-shops').val();
        shopId = $('select.js-orders-puck-up-source-shops').val();
      }

      if (shopId != '' && shopId != undefined) {
        process_fill_shop_products(shopId);
      }
    }

    $('#order-items-nested-form')
      .on('cocoon:after-insert', function (e, added_item) {
        added_item.after($('#js-link-to-add-item'));

        initSelect2ProductsAjax($('.modal.js-order-item-modal'), added_item.find('.js-source-products-ajax'));
        handleSelectProductAjax();
      });
  });

  function handleSelectDirectiveTypeProduceOrder($dropdownParent) {
    $('.js-select-directive-type').select2({
      dropdownParent: $dropdownParent,
      language: { noResults: function () { return "見つかりません"; } }
    });

    $('.js-select-directive-type').on('select2:select', function (e) {
      let data = e.params.data;
      let elem = $(this).parent().parent().find('.js-unit-type-col');

      if (data.id == 'directive_product') {
        $(elem).html('個');
      } else if (data.id == 'directive_dough') {
        $(elem).html('本');
      } else if (data.id == 'directive_remain_dough') {
        $(elem).html('キロ');
      }
    });
  }

  function initSelect2OrderSourceShops(onModal = false) {
    let options = {
      ajax: {
        url: '/shops.json',
        dataType: 'json',
        data: function (params) {
          return {
            q: { name_or_code_cont: params.term },
            page: params.page || 1
          }
        },
        processResults: function (data, params) {
          params.page = params.page || 1;

          return {
            results: $.map(data, function (item) {
              let item_name = item.name;
              let item_code = item.code;
              let payment_type = item.payment_type;

              return { text: item_code + " " + item_name, id: item.id, payment_type: payment_type }
            })
          };
        },
        cache: true,
        minimumInputLength: 2
      },
      placeholder: "店舗コード - 店舗名",
      language: {
        noResults: function () {
          return "見つかりません";
        }
      },
      selectOnClose: false
    };

    if (onModal) {
      options.dropdownParent = onModal;
    }

    $('.js-orders-source-shops').select2(options);
    $('.js-orders-puck-up-source-shops').select2(options);
  }

  updateOrderSummary();

  $(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus();
  });

  $(document).on('click', '.js-btn-update-order-item-status', function (e) {
    e.preventDefault();

    let item_id = $(this).data('item-id');
    let update_status = '';
    if ($(this).hasClass('btn-order-item-status-not_accept_yet')) {
      update_status = 'planed_to_deliver';
    } else if ($(this).hasClass('btn-order-item-status-planed_to_deliver')) {
      update_status = 'not_accept_yet';
    }

    if (item_id != "" && update_status != "") {
      $.ajax({
        url: '/order_items/update_status',
        method: 'POST',
        data: {
          id: item_id,
          order_item: { status: update_status },
          'authenticity_token': $('meta[name="csrf-token"]').attr('content')
        }
      }).done(function () {
      });
    }
  });

  $(document).on('change', '.order-items-data .js-item-checkbox', function () {
    var productName = $(this).data("product-name");
    var isChecked = $(this).prop("checked");
    $.each($(".order-items-data .js-item-checkbox:checked"), function (i, el) {
      if (productName == $(el).data("product-name")) {
        $(el).prop("checked", false)
      }
    });

    $(this).prop("checked", isChecked);
  });

  $(document).on('click', '.js-add-order-items-btn', function (e) {
    e.preventDefault();

    let btn_state = $(this).data('btn-state');
    var shopId = '';

    if (btn_state == "onModal") {
      shopId = $('input.js-selected-shop-id').val();

      if (shopId == '' || shopId == undefined) {
        shopId = $('select.js-orders-source-shops').val();
      }
    } else {
      shopId = $('.js-confirm-fill-products-modal .js-current-select-shop-id').val();
    }

    $('.js-order-item-modal').modal('hide');
    getOrderItemsData(shopId);
  });

  $(document).on('click', '.js-check-duplicate-product-btn', function (e) {
    e.preventDefault();

    let items = $('.order-items-data input.js-item-checkbox:checked');

    var productIdsList = [];
    if (items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        var productId = $(items[i]).data("product-id");
        productIdsList.push(productId);
      }
    }

    var isConfirm = false;

    $.each($(".js-select-product-col select"), function (i, dropdown) {
      if ($(dropdown).val() != "" && $.inArray(parseInt($(dropdown).val()), productIdsList) !== -1) {
        isConfirm = true;
      }
    });

    if (isConfirm) {
      $('#confirm-modal').modal('show');
    } else {
      $(".js-append-order-items-checked-btn").trigger("click");
    }
  });

  $(document).on('click', '.js-append-order-items-checked-btn, .js-confirm-order-item-modal-ok-btn', function (e) {
    e.preventDefault();

    let onModalDeliver = false;
    let btnOnModal = $(this).data('on-modal');
    let confirmOverWrite = false;

    if ($(this).hasClass('js-confirm-order-item-modal-ok-btn')) {
      confirmOverWrite = true;
    }

    if (btnOnModal != undefined && btnOnModal == 'add_products_deliver_modal') {
      onModalDeliver = true;
    }

    var items = $('.order-items-data input.js-item-checkbox:checked');

    if (onModalDeliver) {
      $('.js-add-order-items-data-modal').modal('hide');
      close_confirm_modal();
      $('.js-order-item-modal').modal('show');
      $('.js-order-item-modal').find('#js_state_add_items').val('add_history_items');
      processAppendShopProductsToModal(items, confirmOverWrite, true);
    } else {
      processAppendShopProductsToModal(items, confirmOverWrite);

      close_confirm_modal();
      close_modal_add_order_items();
    }
  });

  function processAppendShopProductsToModal(items, confirmOverWrite = false, onModalDeliver = false) {
    let existed_items = [];
    if (confirmOverWrite) {
      $('#order-items-nested-form .row-content').find('.row.item').remove();
    } else {
      existed_items = $('#order-items-nested-form .row-content').find('.row.item');
    }

    for (let i = 0; i < items.length; i++) {
      $('#order-items-nested-form .row-content a.js-add-one-item').click();
    }

    for (let i = existed_items.length; i < items.length + existed_items.length; i++) {
      let product_items = $('#order-items-nested-form .row-content').find('.row.item');
      let inserted_item = product_items[i];
      let item_data = items[i - existed_items.length];

      var productName = $(item_data).data("product-name");
      var productId = $(item_data).data("product-id");
      var amount = $(item_data).data("amount");
      var unitPrice = $(item_data).data("unit-price");
      var priceTotal = $(item_data).data("price");

      var newOption = new Option(productName, productId, true, true);
      $(inserted_item).find('.js-source-products-ajax').append(newOption).trigger('change');

      $(inserted_item).find('.js-product-price-col .js-product-price').val(unitPrice);
      $(inserted_item).find('input.js-order-item-amount').val(amount);
      $(inserted_item).find('input.js-order-total-fee').val(priceTotal);
    }
  }

  $(document).on('click', '.js-close-modal-add-order-items', function (e) {
    e.preventDefault();
    $('.js-add-order-items-data-modal').modal('hide');
    $('.js-add-order-items-btn').focus();

    let onModalDeliver = false;
    let btnOnModal = $(this).data('on-modal');
    if (btnOnModal != undefined && btnOnModal == 'add_products_deliver_modal') {
      onModalDeliver = true;
    }

    if (onModalDeliver) {
      close_modal_add_order_items();
      $('.js-order-item-modal').modal('show');
    } else {
      close_modal_add_order_items();
    }
  });

  $(document).on('click', '.js-confirm-cancel-btn', function (e) {
    e.preventDefault();

    close_confirm_modal();
  });

  function getOrderItemsData(shopId) {
    if (shopId != "") {
      $.ajax({
        url: '/orders/get_orders_by_shop',
        method: 'GET',
        data: { id: shopId, 'authenticity_token': $('meta[name="csrf-token"]').attr('content') }
      }).done(function (response) {
        $(".js-add-order-items-data-modal .order-items-data").html("");
        var str = "";
        if (response.data.length > 0) {
          $.each(response.data, function (i, order) {
            if (order.items.length != 0) {
              str += `<div class="mt-3 date-strf">${order.date_strf}</div>
            <div class="card mt-1">
              <div class="card-body">
                <div class="workers-list-wrapper modal-order-items-list-items">
                  <div class="workers-list">
                    <div class="row row-head">
                      <div class="col-1"></div>
                      <div class="col-4">商品名</div>
                      <div class="col-2">個数</div>
                      <div class="col-2">単価</div>
                      <div class="col-3">金額</div>
                    </div>
                    <div class="row-content">`;

              $.each(order.items, function (j, item) {
                str += `<div class="row row-item">
                        <div class="col-1 d-margin-auto text-center">
                          <input type="checkbox" class="js-item-checkbox" data-product-name="${item.product_name}" data-product-id="${item.product_id}"
                          data-amount="${item.amount}" data-unit-price="${item.unit_price}" data-price="${item.price}"
                          data-product-code="${item.product_code}" data-product-general-name="${item.product_general_name}" />
                        </div>
                        <div class="col-4 d-margin-auto">
                          ${item.product_name}
                        </div>
                        <div class="col-2 d-margin-auto">
                          ${numberWithCommas(item.amount)}
                        </div>
                        <div class="col-2 d-margin-auto">
                          ¥${numberWithCommas(item.unit_price)}
                        </div>
                        <div class="col-3 d-margin-auto">
                          ¥${numberWithCommas(item.price)}
                        </div>
                      </div>`;
              });

              str += `</div>
                  </div>
                </div>
              </div>
            </div>
          </div>`;
            }
          });
        } else {
          str += `<div class="card mt-1">
              <div class="card-body">
                <div class="workers-list-wrapper modal-order-items-list-items">
                  <div class="workers-list">
                    <div class="row row-head">
                      <div class="col-1"></div>
                      <div class="col-4">商品名</div>
                      <div class="col-2">個数</div>
                      <div class="col-2">単価</div>
                      <div class="col-3">金額</div>
                    </div>
                    <div class="row-content">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>`;
        }

        $(".js-add-order-items-data-modal .order-items-data").append(str);
        $('.js-add-order-items-data-modal').modal('show');
      });
    }
  }

  function close_modal_add_order_items() {
    initSelect2ProductsAjax();
    $('.js-add-order-items-data-modal').modal('hide');
  }

  function close_confirm_modal() {
    initSelect2ProductsAjax();
    $('#confirm-modal').modal('hide');
  }

  function fillProductSelectShopOnOrder() {
    $('.js-orders-source-shops').on('select2:select', function (e) {
      var data = e.params.data;

      let current_selected_shop_id = $('input.js-selected-shop-id').val();
      var shopDropdownCount = localStorage.getItem("shopDropdownCount");

      $('.js-confirm-fill-products-modal .js-current-select-shop-id').val(data.id);
      $('.js-current-shop-payment-type').val(data.payment_type);

      if (parseInt(shopDropdownCount) > 0) {
        $('.js-confirm-fill-products-modal').modal('show');
      } else {
        process_fill_shop_products(data.id);
        localStorage.setItem("shopDropdownCount", shopDropdownCount + 1);
        focusToFirstAmountField();
        display_summerize_on_orders_new();
      }
    });
  }

  $(document).on('click', '.js-confirm-fill-products-modal .js-cancel-btn', function (e) {
    e.preventDefault();

    let current_selected_shop_id = $('input.js-selected-shop-id').val();
    $('.js-orders-source-shops').val(current_selected_shop_id).trigger('change');
    $('.js-confirm-fill-products-modal').modal('hide');
    $('.js-orders-source-shops').select2('focus');

    resetSelect2();
  });

  $(document).on('click', '.js-confirm-fill-products-modal .js-confirm-ok-btn', function (e) {
    e.preventDefault();

    let current_selected_shop_id = $('input.js-current-select-shop-id').val();

    $('input.js-selected-shop-id').val(current_selected_shop_id);
    $('.js-orders-source-shops').val(current_selected_shop_id).trigger('change');
    $('.js-confirm-fill-products-modal').modal('hide');
    $('.js-orders-source-shops').select2('focus');

    process_fill_shop_products(current_selected_shop_id);
    setTabIndex();

    display_summerize_on_orders_new();
  });

  $(document).on('change', '.js-input-file-field', function (e) {
    e.preventDefault();

    $(".js-form-import-csv-btn").trigger("click");
    $('.js-importing-notify-modal').modal('show');
  });

  function display_summerize_on_orders_new() {
    let current_shop_payment_type = $('.js-current-shop-payment-type').val();

    if (current_shop_payment_type == 'credit') {
      $('.js-order-summerize-area').addClass('d-none');
    } else {
      $('.js-order-summerize-area').removeClass('d-none');
    }

    updateOrderSummary();
  }

  function process_fill_shop_products(shop_id) {
    $.ajax({
      url: '/shop_products/list_order_shop_products',
      method: 'POST',
      data: { shop_id: shop_id, 'authenticity_token': $('meta[name="csrf-token"]').attr('content') }
    }).done(function (rsp) {
      $('#order-items-nested-form .row-content').find('.row.item').remove();

      if (rsp.length > 0) {
        for (let i = 0; i < rsp.length; i++) {
          $('#order-items-nested-form .row-content a.js-add-one-item').click();
        }

        for (let i = 0; i < rsp.length; i++) {
          let product_items = $('#order-items-nested-form .row-content').find('.row.item');
          let inserted_item = product_items[i];

          var newOption = new Option(rsp[i].text, rsp[i].id, true, true);
          var item_code = rsp[i].text.split('、')[1];
          var sales_user_code = item_code.split('-')[0];

          $(inserted_item).find('.js-source-products-ajax').append(newOption).trigger('change');
          $(inserted_item).find('.js-product-price-col .js-product-price').val(numberWithCommas(rsp[i].display_price));
          $(inserted_item).find('label.js-product-unit-type').html(rsp[i].unit_type);

          if (sales_user_code) {
            $(inserted_item).find('.js-sales-user-code').val(sales_user_code);
          }
          $(inserted_item).find('.js-product-tax-val').val(rsp[i].correct_tax_val);

          // if (rsp[i].unit_type == UNIT_KG) {
          //   $(inserted_item).find('input.js-order-item-amount').removeClass('int-field').removeClass('float-field');
          //   $(inserted_item).find('input.js-order-item-amount').removeClass('js-format-int-field-blur').addClass('js-format-float-field-blur');
          // } else {
          //   $(inserted_item).find('input.js-order-item-amount').removeClass('float-field').removeClass('int-field');
          //   $(inserted_item).find('input.js-order-item-amount').removeClass('js-format-float-field-blur').addClass('js-format-int-field-blur');
          // }

          $(inserted_item).find('input.js-order-item-amount').removeClass('int-field').removeClass('float-field');
          $(inserted_item).find('input.js-order-item-amount').removeClass('js-format-int-field-blur').addClass('js-format-float-field-blur');
        }
      } else {
        $('#order-items-nested-form .row-content a.js-add-five-items').click();
      }
    });
  }

  function handleFilterDateRaditoChangeState() {
    let item_dom = 'input[type="radio"][name="order[delivery_options]"]';

    $(item_dom).change(function () {
      let parent = $(this).parents('.js-filter-delivery-date-options');
      let input_dom1 = 'input[name="order[delivery_date1]"';
      let input_dom2 = 'input[name="order[delivery_date2]"';
      let input_date1 = $(parent).find(input_dom1);
      let input_date2 = $(parent).find(input_dom2);

      if (this.value == 'on_time') {
        $(input_date1).val('');
        $(input_date2).val('');
        $(input_date1).prop('disabled', true);
        $(input_date2).prop('disabled', true);
      } else if (this.value == 'range_time') {
        $(input_date1).prop('disabled', false);
        $(input_date2).prop('disabled', false);
      } else if (this.value == 'all_time') {
        $(input_date1).val('');
        $(input_date2).val('');
      }
    });
  }

  function initSelect2ProductsAjax(onModal = false, $specific_item = null) {
    let $dom_elem = $('.js-source-products-ajax');

    if ($specific_item != null) {
      $dom_elem = $specific_item;
    }

    let options = {
      ajax: {
        url: '/products.json',
        dataType: 'json',
        data: function (params) {
          let query = { name_or_code_or_general_name_or_client_products_special_product_name_cont: params.term };

          let except_product_ids = [];
          let items = $('.js-select-product-col select.js-source-products-ajax');
          for (let i = 0; i < items.length; i++) {
            let p_id = $(items[i]).val();
            if (p_id != null && p_id != "") {
              except_product_ids.push(p_id);
            }
          }

          return {
            q: query,
            shop_id_selected: $('select.js-orders-source-shops').val(),
            except_product_ids: except_product_ids,
            page: params.page || 1,
            per_page: 25
          }
        },
        processResults: function (data, params) {
          params.page = params.page || 1;

          return {
            results: $.map(data, function (item) {
              let item_name = item.name;
              let item_price = item.price;
              let item_unit_type = item.unit_type_localization;
              let product_tax_val = item.correct_tax_val;

              if (item.client_id_selected != null) {
                for (let i = 0; i < item.client_products.length; i++) {
                  if (item.client_id_selected == item.client_products[i].client_id) {
                    item_name = item.client_products[i].special_product_name;
                    item_price = item.client_products[i].price;

                    break;
                  }
                }
              }

              let item_code = item.code;
              if (item.sales_user_code != null && item.sales_user_code != '') {
                item_code = item.sales_user_code + '-' + item.code;
              }
              let item_text_display = item_name + '、' + item_code;
              if (item.general_name != null && item.general_name != '') {
                item_text_display += '、' + item.general_name;
              }

              return {
                text: item_text_display, id: item.id,
                price: item_price, unit_type: item_unit_type,
                product_tax_val: product_tax_val
              }
            })
          };
        },
        cache: true,
        minimumInputLength: 1
      },
      language: {
        noResults: function () {
          return "見つかりません";
        }
      },
      selectOnClose: false
    };

    if (onModal) {
      options.dropdownParent = onModal;
    }

    $dom_elem.select2(options);
  }

  function handleSelectShopOrder() {
    $('.js-orders-source-shops').on('select2:select', function (e) {
      var data = e.params.data;
      var shop_id = data.id;

      $(this).closest(".orders-form-block").find(".js-add-order-items-btn").removeClass("d-none");
    });
  }

  function correctNumberFieldByFormatted(input_value, item_type) {
    if (!input_value) return "";

    let normalized = toHalfWidth(String(input_value).trim());

    normalized = normalized.replace(/,/g, '');

    return item_type === 'int' ? parseInt(normalized, 10) : parseFloat(normalized);
  }

  function handleSelectProductAjax() {
    $('.js-source-products-ajax').on('select2:select', function (e) {
      var data = e.params.data;

      var item_code = data.text.split('、')[1];
      var sales_user_code = item_code.split('-')[0];

      var current_row = $(e.currentTarget).parents('.row.item');
      var item_amount = $(current_row).find('.js-order-item-amount-col input.js-order-item-amount').val().trim();
      var item_price = numberWithCommas(data.price);
      const $input_order_total_fee = $(current_row).find('.js-order-total-fee-col input.js-order-total-fee');

      $(current_row).find('.js-order-item-amount-col label.js-product-unit-type').html(data.unit_type);
      $(current_row).find('.js-product-price-col input.js-product-price').val(item_price);
      $(current_row).find('.js-source-products-ajax').val(data.id).trigger('change');
      $(current_row).find('.js-select-product-col').find('.select2-selection__rendered').text(data.text);
      if (sales_user_code) {
        $(current_row).find('.js-sales-user-code').val(sales_user_code);
      }
      $(current_row).find('.js-product-tax-val').val(data.product_tax_val);

      if (item_amount != "") {
        var dataPrice = new Decimal(parseFloat(data.price));
        var dataAmountConvert = correctNumberFieldByFormatted(item_amount);
        var dataAmount = new Decimal(dataAmountConvert);
        var order_item_total_fee = dataPrice * dataAmount;
        order_item_total_fee = parseInt(order_item_total_fee);

        var display_order_item_total_fee = numberWithCommas(order_item_total_fee);
        setOrderInputFieldValue($input_order_total_fee, display_order_item_total_fee);
      }

      // if (data.unit_type == UNIT_KG) {
      //   $(current_row).find('input.js-order-item-amount').removeClass('int-field').removeClass('float-field');
      //   $(current_row).find('input.js-order-item-amount').removeClass('js-format-int-field-blur').addClass('js-format-float-field-blur');
      // } else {
      //   $(current_row).find('input.js-order-item-amount').removeClass('float-field').removeClass('int-field');
      //   $(current_row).find('input.js-order-item-amount').removeClass('js-format-float-field-blur').addClass('js-format-int-field-blur');
      // }

      $(current_row).find('input.js-order-item-amount').removeClass('int-field').removeClass('float-field');
      $(current_row).find('input.js-order-item-amount').removeClass('js-format-int-field-blur').addClass('js-format-float-field-blur');
    });

    $('input.js-order-item-amount').keyup(function (event) {
      var current_row = $(this).parents('.row.item');
      var product_price = $(current_row).find('.js-product-price-col input.js-product-price').val();

      setTimeout(function() {
        var formatted_current_input = $(this).val().trim();
        
        product_price = correctNumberFieldByFormatted(product_price);
        formatted_current_input = correctNumberFieldByFormatted(formatted_current_input);

        const $input_order_total_fee = $(current_row).find('.js-order-total-fee-col input.js-order-total-fee');

        if (formatted_current_input == undefined || formatted_current_input == '') {
          setOrderInputFieldValue($input_order_total_fee, '');
        }

        if ($.isNumeric(formatted_current_input) && $.isNumeric(product_price)) {
          let item_amount_converted = new Decimal(formatted_current_input);
          let product_price_converted = new Decimal(product_price);
          var order_item_total_fee = item_amount_converted.mul(product_price_converted);

          let formatted_order_item_total_fee =
              order_item_total_fee % 1 === 0
                  ? order_item_total_fee
                  : order_item_total_fee.toString().split('.')[0];
          formatted_order_item_total_fee = parseInt(formatted_order_item_total_fee);
          var display_order_item_total_fee = numberWithCommas(formatted_order_item_total_fee);
          setOrderInputFieldValue($input_order_total_fee, display_order_item_total_fee);
        }
      }.bind(this), 60);
    });

    $('input.js-product-price').keyup(function (event) {
      var current_row = $(this).parents('.row.item');
      let order_item_amount = $(current_row).find('.js-order-item-amount-col input.js-order-item-amount').val();

      setTimeout(function() {
        let formatted_current_input = $(this).val().trim();
        
        order_item_amount = correctNumberFieldByFormatted(order_item_amount);
        formatted_current_input = correctNumberFieldByFormatted(formatted_current_input);

        if ($.isNumeric(formatted_current_input) && $.isNumeric(order_item_amount)) {
          let item_amount_converted = new Decimal(formatted_current_input);
          let product_price_converted = new Decimal(order_item_amount);
          var order_item_total_fee = item_amount_converted.mul(product_price_converted);

          let formatted_order_item_total_fee =
              order_item_total_fee % 1 === 0
                  ? order_item_total_fee
                  : order_item_total_fee.toString().split('.')[0];
          formatted_order_item_total_fee = parseInt(formatted_order_item_total_fee);
          var display_order_item_total_fee = numberWithCommas(formatted_order_item_total_fee);
          $(current_row).find('.js-order-total-fee-col input.js-order-total-fee').val(display_order_item_total_fee);
        }

        if (formatted_current_input == null || formatted_current_input == "") {
          $(current_row).find('.js-order-total-fee-col input.js-order-total-fee').val("");
        }
      }.bind(this), 60);
    });
  }

  function setTabIndex() {
    localStorage.setItem("tabIndex", 0);
  }

  function resetShopDropdown() {
    localStorage.setItem("shopDropdownCount", 0);
  }

  // Press Tab and Shift Tab to next and previous amount element
  document.onkeydown = function (e) {
    if (e.ctrlKey) {
      // e.preventDefault(); If uncomment this line, we can not copy & paste using ctrl + c, v

      if (e.keyCode == 79) {
        window.location.href = '/orders/new';
      }
    }
  };

  function setVariableEditMode(fieldSet) {
    isEditMode = true;
    fieldSet.addClass('editing');
  }

  function resetVariableEditMode(fieldSet) {
    isEditMode = false;
    fieldSet.removeClass('editing');
  }

  function focusInputField($field, isClick = true) {
    if ($field && $field.length) {
      setVariableEditMode($field)
      const element = $field[0];
      element.focus();

      if (isClick) {
        if (
          (element.tagName === "INPUT" && ["text", "search"].includes(element.type)) ||
          element.tagName === "TEXTAREA"
        ) {
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      }
    }
  }

  function focusToFirstAmountField() {
    var el = $("#order-items-nested-form .js-order-item-amount");
    var totalEl = el.length;
    if (totalEl > 0) {
      setTimeout(() => focusInputField($($(el)[0])), 100);
    }
  }

  $(document).on('click', '.js-btn-order-submit', function (e) {
    const $button = $(this);
    const form = $button.closest('form')[0];

    // Prevent multiple clicks by disabling the button
    if ($button.prop('disabled')) {
      e.preventDefault();
      return false;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return false;
    }

    // Disable button and show loading state
    $button.prop('disabled', true);
    
    // Add a small delay to ensure the button state is updated
    setTimeout(() => {
      form.submit();
    }, 100);
  });

  function handleFormSubmission(e) {
    e.preventDefault();
    const $button = $('.order-form-inline .js-btn-order-submit');
    
    // Only trigger click if button is not disabled
    if (!$button.prop('disabled')) {
      $button.trigger('click');
    }
  }
  function getProduces(productId) {
    if (productId !== "") {
      $.ajax({
        url: `/orders/show_product`,
        method: "GET",
        data: { product_id: productId },
        dataType: 'script'
      })
    }
  }

  $(document).ready(function () {
    let $currentField = null;
    let fieldValues = new Map();

    $(document).on('click', '.form-short-key input,.form-short-key textarea', function (e) {
      enterEditMode($(this), false);
    });

    function getAllVisibleFields() {
      return $(".form-short-key .order-form-inline").find('input, select, button, a, textarea, .select2-selection')
        .filter(':visible')
        .not('.js-order-total-fee, .select2-hidden-accessible');
    }

    function focusField($field) {
      $field.focus();
      if ($field.hasClass('select2-selection')) {
        $field.trigger('click');
      }
    }

    function enterEditMode($field, isClick = true) {
      $currentField = $field;
      setVariableEditMode($field)

      fieldValues.set($field[0], $field.val());

      setTimeout(() => {
        $field.focus();
      }, 0);

      if (isClick) {
        setTimeout(() => {
          const element = $field[0];

          if (!element) return;
          if (
            (element.tagName === "INPUT" &&
              ["text", "search"].includes(element.type)) ||
            element.tagName === "TEXTAREA"
          ) {
            const length = element.value.length;
            element.setSelectionRange(length, length);
          }
        }, 0);
      }
    }

    function exitEditMode($field, moveToNext = true) {
      isEditMode = false;
      $field.removeClass('editing');

      fieldValues.delete($field[0]);

      if (moveToNext) {
        const $allFields = getAllVisibleFields();
        const currentIndex = $allFields.index($field);
        const $nextField = $allFields.eq(currentIndex + 1);
        if ($nextField.length) {
          setTimeout(() => focusField($nextField), 0);
        }
      }
    }

    function triggerDeleteAndFocus($field) {
      const $currentRowDelete = $field.closest('.row.item[data-item-id]');
      const $currentRowDeleteId = $currentRowDelete.data('item-id');
      initSelect2ProductsAjax();
      let nextRow = null;
      let prevRow = null;

      $('.row.item[data-item-id]').each(function () {
        if ($(this).data('item-id') == $currentRowDeleteId) {
          let currentRowDelete = $(this);
          nextRow = currentRowDelete.next('.row.item[data-item-id]');
          prevRow = currentRowDelete.prev('.row.item[data-item-id]');
          $(this).remove();
          return false;
        }
      });

      $currentRowDelete.find('.btn-sm-destroy').trigger('click');
      if (nextRow && nextRow.length > 0) {
        const $nextItem = nextRow.find('.js-source-products-ajax');
        if ($nextItem.length > 0) {
          focusOnProductSelect(nextRow);
          return false;
        }
      }

      if (prevRow && prevRow.length > 0) {
        const $prevItem = prevRow.find('.js-source-products-ajax');
        if ($prevItem.length > 0) {
          focusOnProductSelect(prevRow);
        }
      }

      if (prevRow.length == 0 && nextRow.length == 0) {
        const $targetField = $('.js-add-five-items').first();
        setTimeout(function () {
          $targetField.trigger('focus');
        }, 50);
      }
    }

    $(document).on('focus', '.form-short-key input,.form-short-key textarea,.form-short-key select,.form-short-key button,.form-short-key .select2-selection', function (e) {
      const $field = $(this);
      if (!fieldValues.has($field[0])) {
        fieldValues.set($field[0], $field.val());
      }

      if (!isEditMode) {
        e.preventDefault();
        if (window.getSelection) {
          window.getSelection().removeAllRanges();
        }
        resetVariableEditMode($field);
      }
    });

    $(document).on('blur', 'input, textarea, select, button, .select2-selection', function (e) {
      isEditMode = false;
    });

    $('input[type="submit"]').removeAttr('data-disable-with');
    const $form = $(".form-short-key .order-form-inline");
    $($form).on('keydown', 'input, textarea', function (e) {
      const $field = $(this);


      if (!isEditMode) {
        if ((e.shiftKey && e.key === '*') || e.code === 'NumpadMultiply') {
          return;
        }

        if ((e.key.match(/^[a-zA-Z0-9]$/)) || e.key.match(/^[\u0020-\u007E]$/)) {
          $field.val('');
          setVariableEditMode($field)
        }
      }
    });

    $($form).on('click', 'input, textarea', function () {
      if ($(this).closest('.js-order-item-amount').length > 0) {
        focusInputField($(this), false);
      }
    });

    $($form).on('blur', 'input, textarea', function () {
      isEditMode = false;
    });

    $form.on('keydown', 'input, select, button, a, textarea, .select2-selection, input[type="submit"]', function (e) {
      const $field = $(this);
      const $allFields = getAllVisibleFields();
      const fieldIndex = $allFields.index($field);
      let $targetField;

      function isSelect2Open() {
        return $('.select2-container--open').length > 0;
      }

      if (isSelect2Open()) {
        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
          e.preventDefault();
        }
        return;
      }
      if (e.code === 'NumpadMultiply') {
        if ($field.hasClass('editing')) return;
        if (fieldIndex > 0) {
          $targetField = $allFields.eq(fieldIndex - 1);
        }
      } else {
        switch (e.key) {
          case 'ArrowRight':
            if (isEditMode) return;
            if (fieldIndex < $allFields.length - 1) {
              $targetField = $allFields.eq(fieldIndex + 1);
            }
            break;
          case '*':
          case 'ArrowLeft':
            if (isEditMode) return;
            if ($field.hasClass('editing')) return;
            if (fieldIndex > 0) {
              $targetField = $allFields.eq(fieldIndex - 1);
            }
            break;
          case 'ArrowDown':
            if (isEditMode) return;

            const $currentRow = $field.closest('.row');
            const $currentOrderRow = $currentRow.closest('.orders-form-block');

            if ($currentOrderRow.length) {
              const $firstItemRow = $('.row.item:first');
              const currentFieldName = $field.attr('name') || '';
              const currentControl = $field.attr('aria-controls') || '';
              switch (true) {
                case currentFieldName.includes('infomart_order_code'):
                  $targetField = $firstItemRow.find('.js-source-products-ajax:first'); // 商品名
                  break;
                case currentFieldName.includes('delivery_at'):
                  $targetField = $firstItemRow.find('.js-order-item-amount:first'); // 個数
                  break;
                case currentFieldName.includes('order_at'):
                  $targetField = $firstItemRow.find('.js-product-price:first'); // 単価
                  break;
                case currentControl === 'select2-order_shop_id-container':
                  const $orderMemo = $firstItemRow.find('.js-order-item-memo:first'); // 操作
                  if ($orderMemo.length) {
                    $targetField = $orderMemo
                  } else {
                    const $nextAddFiveItemsButton = $('.js-add-five-items').first();
                    if ($nextAddFiveItemsButton.length) {
                      $targetField = $nextAddFiveItemsButton;
                      break;
                    }
                  }
                case $field.hasClass('js-add-order-items-btn'):
                  const $destroyBtn = $firstItemRow.find('a.btn-sm-destroy:first'); // 操作
                  if ($destroyBtn.length) {
                    $targetField = $destroyBtn
                  } else {
                    const $nextAddFiveItemsButton = $('.js-add-five-items').first();
                    if ($nextAddFiveItemsButton.length) {
                      $targetField = $nextAddFiveItemsButton;
                      break;
                    }
                  }
                  break;
              }
            } else if ($currentRow.hasClass('row')) {
              const $currentItem = $field.closest('.row.item');

              if ($currentItem.length) {
                const $allDeleteOrderRows = $('.content-nested-form .js-confirm-delete-order').closest('.row.item');
                const isLastDeleteOrderRow = $currentItem.is($allDeleteOrderRows.last());
                if (isLastDeleteOrderRow) {
                  const $nextAddFiveItemsButton = $('.js-add-five-items').first();
                  if ($nextAddFiveItemsButton.length) {
                    $targetField = $nextAddFiveItemsButton;
                    break;
                  }
                } else {
                  const $nextItem = $currentItem.next('.row.item');
                  if ($nextItem.length) {
                    const currentFieldIndex = $currentItem
                      .find('input, select, button, a, textarea, .select2-selection')
                      .filter(':visible')
                      .not('.js-order-total-fee, .select2-hidden-accessible')
                      .index($field);

                    $targetField = $nextItem
                      .find('input, select, button, a, textarea, .select2-selection')
                      .filter(':visible')
                      .not('.js-order-total-fee, .select2-hidden-accessible')
                      .eq(currentFieldIndex);
                  }
                }
              } else {
                const $cancelButton = $('.btn-cancel').first();
                if ($cancelButton.length) {
                  $targetField = $cancelButton;
                  break;
                } else {
                  if (fieldIndex < $allFields.length - 1) {
                    $targetField = $allFields.eq(fieldIndex + 1);
                  }
                }
              }
            }
            break;
          case 'ArrowUp':
            if (isEditMode) return false;
            if ($field.hasClass('js-add-order-items-btn')) return false;
            if ($field.attr('aria-controls') == 'select2-order_shop_id-container') return false;
            const $currentItem = $field.closest('.row.item');

            if ($currentItem.length) {
              if ($currentItem.is(':first-child')) {
                const $parent = $field.closest('.js-select-product-col');
                switch (true) {
                  case $parent.length && !$field.is($parent): // Từ 商品名
                    $targetField = $('[name*="infomart_order_code"]');
                    break;
                  case $field.hasClass('js-order-item-amount'): // Từ 個数
                    $targetField = $('[name*="delivery_at"]');
                    break;
                  case $field.hasClass('js-product-price'): // Từ 単価
                    $targetField = $('[name*="order_at"]');
                    break;
                  case $field.hasClass('js-order-item-memo'): // Từ メモ
                    $targetField = $('.js-orders-source-shops');
                    break;
                  case $field.hasClass('btn-sm-destroy'): // Từ 操作
                    const $orderHistoryBtn = $('.js-add-order-items-btn:visible');
                    $targetField = $orderHistoryBtn.length && !$orderHistoryBtn.hasClass('d-none')
                      ? $orderHistoryBtn
                      : $('.js-orders-source-shops');
                    break;
                }
              } else {
                const $prevItem = $currentItem.prev('.row.item');
                if ($prevItem.length) {
                  const currentFieldIndex = $currentItem
                    .find('input, select, button, a, textarea, .select2-selection')
                    .filter(':visible')
                    .not('.js-order-total-fee, .select2-hidden-accessible')
                    .index($field);

                  $targetField = $prevItem
                    .find('input, select, button, a, textarea, .select2-selection')
                    .filter(':visible')
                    .not('.js-order-total-fee, .select2-hidden-accessible')
                    .eq(currentFieldIndex);
                }
              }
            } else {
              $targetField = $('.js-add-five-items');
              const $newCurrentItem = $field.closest('.row');
              if ($newCurrentItem.find('.js-add-five-items').length) {
                const $nextRow = $newCurrentItem.prev('.row');
                const $destroyBtn = $nextRow.find('.btn-sm-destroy').first();
                if ($destroyBtn.length) {
                  $targetField = $destroyBtn;
                } else {
                  if (fieldIndex > 0) {
                    $targetField = $allFields.eq(fieldIndex - 1);
                  }
                }
              }
            }
            break;
          case 'Escape':
            if (isEditMode && $field) {
              e.preventDefault();
              const originalVal = fieldValues.get($field[0]);
              if (originalVal !== undefined) {
                $field.val(originalVal);
              }
            }
            break;
          case 'Enter':
            e.preventDefault();
            
            if ($field.hasClass('js-add-order-items-btn')) {
              $('.js-add-order-items-btn').trigger('click');
              break;
            }

            if ($field.hasClass('js-add-five-items')) {
              $(".js-add-five-items").trigger('click');
              break;
            }

            if ($field.hasClass('btn-cancel')) {
              $(".btn-cancel").trigger('click');
              break;
            }

            if ($field.hasClass('btn-sm-destroy')) {
              triggerDeleteAndFocus($(this));
              break;
            }

            if ($field.hasClass('btn-save')) {
              handleFormSubmission(e);
              break;
            }

            if (isEditMode) {
              exitEditMode($field);
            } else {
              enterEditMode($field);
            }
            break;
          case 'F2':
            e.preventDefault();
            triggerDeleteAndFocus($(e.target));
            break;
          case 'F3':
            e.preventDefault();
            const currentRow = $(e.target).closest('.row.item');
            const currentRowClone = currentRow.clone(true);

            const timestamp = Date.now();
            const itemId = crypto.randomUUID()
            const newTimestamp = Date.now();
            const oldTimestamp = currentRow.find('input, select, textarea').first().attr('name')?.match(/\[(\d+)\]/)?.[1];

            currentRowClone.attr('data-item-id', itemId);
            currentRowClone.data('item-id', itemId);

            currentRowClone.find('*').each(function () {
              const $el = $(this);

              if ($el.attr('id')) {
                $el.attr('id', $el.attr('id').replace(oldTimestamp, newTimestamp));
              }
              if ($el.attr('name')) {
                $el.attr('name', $el.attr('name').replace(oldTimestamp, newTimestamp));
              }
              if ($el.attr('for')) {
                $el.attr('for', $el.attr('for').replace(oldTimestamp, newTimestamp));
              }
            })

            currentRowClone.find('.form-short-key input, select, textarea').each(function () {
              const $formField = $(this);
              if ($formField.hasClass('select2-hidden-accessible')) {
                // Update IDs to avoid duplication
                const oldId = $formField.attr('id');
                const newId = oldId.replace(/\d+/, timestamp);
                $formField.attr('id', newId);
                $formField.attr('name', $formField.attr('name').replace(/\d+/, timestamp));

                // Clear select2
                currentRowClone.find('[data-select2-id]').removeAttr('data-select2-id');
                $formField.removeClass('select2-hidden-accessible')
                  .removeData('select2');
                currentRowClone.find('.select2-container').remove();
                $formField.find('option:selected').removeAttr('selected');
                $formField.val(null);
              } else {
                $formField.val('');
              }
            });

            currentRow.after(currentRowClone);
            initSelect2ProductsAjax(false, currentRowClone.find('.js-source-products-ajax'));
            currentRowClone.find('.js-product-price, .js-order-item-amount, .js-order-total-fee').val('');
            break;
          case 'F1':
            e.preventDefault();
            if ($field.closest('.js-select-product-col').length) {
              const currentRow = $(e.target).closest('.row.item');
              var productId = $($(currentRow).find('.js-select-product-col select.js-source-products-ajax')[0]).val() + "";

              if (productId) {
                getProduces(productId);
              }
              const itemId = $(currentRow).data('item-id')
              $('#product-detail-modal').attr("data-item-id", itemId);
              $('#product-detail-modal').data("item-id", itemId);
            }
            break;
          case 'Tab':
            const isShiftTab = e.shiftKey && e.key === 'Tab';
            const $amountFields = $('.form-short-key .js-order-item-amount:visible');
            const index = $amountFields.index($field);
            const $addFiveItemsBtn = $('.form-short-key .js-add-five-items:visible').first();
            const $submitButton = $('.form-short-key .btn-save:visible').first();

            const $validFields = $amountFields.add($addFiveItemsBtn).add($submitButton);

            const $currentField = $(e.target);
            const isInsideContentNestedForm = $currentField.closest('.content-nested-form').length
            const $sourceShopsField = $('.form-short-key .js-orders-source-shops:visible').first();
            const isIntField = $('.form-short-key .int-field:visible').first();
            const isSingleDateField = $('.form-short-key .singledate:visible').first();
            const $addItemButton = $('.form-short-key .js-add-order-items-btn:visible').first();


            if (isSingleDateField.is($currentField) && isShiftTab) {
              const $focusableFields = $('.form-short-key input:visible').filter(':not([readonly])');
              const index = $focusableFields.index($currentField);
              const $previousField = $focusableFields.eq(index - 1);

              if (!$previousField.is(isIntField)) {
                e.preventDefault();
                return false;
              }
            } else if (isIntField.is($currentField) && isShiftTab) {
              e.preventDefault();
              return false;
            }

            if (isInsideContentNestedForm) {
              if (!$validFields.is($currentField)) {
                e.preventDefault();
                return false;
              }
            }

            if ($validFields.is($currentField) || $sourceShopsField.is($currentField) || $addItemButton.is($currentField)) {
              e.preventDefault();

              if (isShiftTab) {
                if ($submitButton.is($field)) {
                  $targetField = $addFiveItemsBtn.length ? $addFiveItemsBtn : $amountFields.last();
                } else if ($addFiveItemsBtn.is($field)) {
                  $targetField = $amountFields.last();
                } else if (index > 0) {
                  $targetField = $amountFields.eq(index - 1);
                } else if ($addItemButton.is($currentField)) {
                  $targetField = $sourceShopsField;
                } else if ($amountFields.is($currentField)) {
                  if ($addItemButton.length) {
                    $targetField = $addItemButton;
                  } else if ($sourceShopsField.length) {
                    $targetField = $sourceShopsField;
                  }
                } else if (index > 0) {
                  $targetField = $amountFields.eq(index - 1);
                }
              } else {

                // ======= TAB =======
                if ($addItemButton.first().is($currentField)) {
                  $targetField = $amountFields.first();
                } else if ($sourceShopsField.is($currentField)) {
                  if ($amountFields.length) {
                    $targetField = $amountFields.first();
                  }
                } else {
                  if (index !== -1 && index < $amountFields.length - 1) {
                    $targetField = $amountFields.eq(index + 1);
                  } else if (index === $amountFields.length - 1) {
                    $targetField = $addFiveItemsBtn.length ? $addFiveItemsBtn : $submitButton;
                  } else if ($addFiveItemsBtn.is($field)) {
                    $targetField = $submitButton;
                  }
                }
              }

              if ($field.hasClass('js-order-item-amount')) {
                formatNumberField($field, 2);
                updateOrderItemTotalFee($field)
              }

              if ($field.hasClass('js-product-price')) {
                formatNumberField($field, 2);
                updateOrderItemTotalFee($field)
              }
            }

            if (!$addFiveItemsBtn.is($targetField) && !$submitButton.is($targetField) && !$addItemButton.is($targetField)) {
              setTimeout(() => focusInputField($targetField), 100);
            } else {
              exitEditMode($field);
            }

            break;
          case '/':
            e.preventDefault();
            $field.val('');
            $field.addClass('editing');
            $field.focus();
            break;
        }
      }

      if ($targetField?.length) {
        setTimeout(function () {
          $targetField.focus();
        }, 0);
        e.preventDefault();

        if ($targetField.hasClass('select2-selection')) {
          $targetField.trigger('click');
        }

        if ($targetField[0].type == 'submit') {
          $('.form-short-key input[type="submit"]').on('focus', function () {
            $(this).attr('data-disable-with', '登録');
          });
        }
      }
    });
  });

  // singledate - arrow left and arrow right
  $(document).ready(function () {
    const $form = $(".form-short-key .order-form-inline");
    if (!$form.length) return;

    let activeInput = null;
    let isModalVisible = false;
    $("input.singledate").each(function (index) {
      const $input = $(this);
      if ($input.data("daterangepicker")) {
        const uniqueClass = `daterangepicker-${index + 1}`;
        const daterangepickerInstance = $input.data("daterangepicker");
        daterangepickerInstance.container.addClass(uniqueClass);
      }
    });

    $("input.singledate").on("focus", function () {
      const $input = $(this);

      if (activeInput && activeInput[0] !== $input[0]) {
        const oldDaterangepicker = activeInput.data("daterangepicker");
        oldDaterangepicker.hide();
      }

      activeInput = $input;

      const currentDaterangepicker = $input.data("daterangepicker");
      currentDaterangepicker.show();
    });

    $("input.singledate").on("blur", function () {
      const $input = $(this);

      setTimeout(function () {
        if (activeInput && activeInput[0] === $input[0]) {
          const currentDaterangepicker = activeInput.data("daterangepicker");
          currentDaterangepicker.hide();
          activeInput = null;
        }
      }, 200);
    });

    $(document).on("mousedown", ".daterangepicker", function (e) {
      e.preventDefault();
    });

    $(document).on("mousedown", function (e) {
      if (
        !$(e.target).closest(".daterangepicker").length &&
        !$("input.singledate").is(e.target)
      ) {
        if (activeInput) {
          const currentDaterangepicker = activeInput.data("daterangepicker");
          currentDaterangepicker.hide();
          activeInput = null;
        }
      }
    });

    $(document).on('click', '.form-short-key .btn-cancel', function (e) {
      e.preventDefault();
      $('#confirm_back_modal').modal('show');
    });

    $(document).on('click', '.js-confirm-back-modal-ok-btn', function (e) {
      e.preventDefault();
      const redirectUrl = $('.btn-cancel').attr('href');
      window.location.href = redirectUrl;
    });

    $(document).on('click', '.js-confirm-back-modal-cancel-btn', function (e) {
      e.preventDefault();
      $('#confirm_back_modal').modal('hide');
      $('.btns-control .btn-cancel').focus();
    });

    $(document).on('click', '.form-short-key .btn-cancel', function (e) {
      e.preventDefault();
      $('#confirm_back_modal').modal('show');
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        const isFieldFocused = $(':focus').length > 0;

        if (!isFieldFocused) {
          $('#confirm_back_modal').modal('show');
        }
      }
    });
  });

  function focusProductSelect() {
    const itemId = $('#product-detail-modal').data('item-id');

    if (itemId) {
      setTimeout(() => {
        $('.row[data-item-id="' + itemId + '"]').find('.select2-selection').trigger('focus');
      }, 300);
    }
  }

  $('#product-detail-modal').on('hidden.bs.modal', function () {
    resetSelect2();
    focusProductSelect();
  });

  $(document).on('click', '.js-confirm-product-modal-cancel-btn', function () {
    $('#product-detail-modal').modal('hide');
  });

  $('#product-detail-modal').on('shown.bs.modal', function () {
    const $cancelButton = $(this).find('.js-confirm-product-modal-cancel-btn');
    if ($cancelButton.length > 0) {
      $cancelButton.focus();
    }
    trapFocus($(this));
  });

  $('#confirm_back_modal').on('shown.bs.modal', function () {
    const $cancelButton = $(this).find('.js-confirm-back-modal-cancel-btn');
    if ($cancelButton.length > 0) {
      $cancelButton.focus();
    }
    trapFocus($(this));
  });

  $('.js-add-order-items-data-modal').on('shown.bs.modal', function () {
    trapFocus($(this));
  });

  $(document).on('click', '.js-confirm-delete-modal-cancel-btn', function () {
    const itemId = $('#confirm_delete_modal').data('item-id');

    $('#confirm_delete_modal').modal('hide');
    if (itemId) {
      const $deleteButton = $('.row[data-item-id="' + itemId + '"]').find('.js-confirm-delete-order');
      if ($deleteButton.length) {
        $deleteButton.focus();
      }
    }
    $('#confirm_delete_modal').data('item-id', "");

    initSelect2ProductsAjax();
  });

  // dialog order histories
  $(document).ready(function () {
    var $modal = $('.js-add-order-items-data-modal');
    $modal.on('focus', '.js-item-checkbox', function () {
      $(this).off('keydown').on('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var productName = $(this).data("product-name");
          var isChecked = $(this).prop("checked");
          $.each($(".order-items-data .js-item-checkbox:checked"), function (i, el) {
            if (productName == $(el).data("product-name")) {
              $(el).prop('checked', false).trigger('change');
            }
          });

          $(this).prop('checked', !isChecked).trigger('change');
        }
      });
    });

    $modal.find('.js-close-modal-add-order-items').on('keydown', function (event) {
      if (event.key === 'Enter') {
        $modal.modal('hide');
      }
    });

    $modal.find('.js-check-duplicate-product-btn').on('keydown', function (event) {
      if (event.key === 'Enter') {
        submitForm();
      }
    });

    $modal.find('.js-append-order-items-checked-btn').on('keydown', function (event) {
      if (event.key === 'Enter') {
        submitForm();
      }
    });

    function submitForm() {
      $('.js-check-duplicate-product-btn').trigger('click');
    }
  });

  // add uuid to new item
  $(document).on('cocoon:after-insert', function (e, insertedItem) {
    const itemId = crypto.randomUUID();
    insertedItem.data('item-id', itemId);
    insertedItem.attr('data-item-id', itemId);
  });

  // reset select2 when hidden modal
  $(document).on('hidden.bs.modal', '#confirm_delete_modal, #confirm_back_modal', function () {
    resetSelect2();
  });

  function handleFocusOrderHistoryModal($modal) {
    const $firstCheckbox = $modal.find('.js-item-checkbox').first();
    if ($firstCheckbox.length > 0) {
      setTimeout(function () {
        $firstCheckbox.trigger('focus');
      }, 100);
    } else {
      const $cancelButton = $modal.find('.js-close-modal-add-order-items').first();
      if ($cancelButton.length > 0) {
        $cancelButton.focus();
      }
    }
  }
  $(document).on('shown.bs.modal', '.js-add-order-items-data-modal', function () {
    handleFocusOrderHistoryModal($(this).find('.modal-content'));
  });

  $(document).on('shown.bs.modal', '.js-confirm-fill-products-modal', function () {
    const $cancelButton = $(this).find('.js-cancel-btn');
    if ($cancelButton.length > 0) {
      $cancelButton.focus();
    }
    trapFocus($(this));
  });

  $(document).on('select2:open', function () {
    setTimeout(() => {
      let searchField = document.querySelector('.select2-search__field');
      if (searchField) {
        searchField.focus();
        searchField.select();
      }
    }, 100);
  });

  $('#order_item_search input').on('focus', function () {
    $('#last_focused_field').val(this.id);
  });

  $('#order_item_search').on('click keydown', function (e) {
    const $target = $(e.target);
    const isImport = $target.hasClass('js-btn-import-order');
    const isAddOrder = $target.hasClass('js-btn-add-order');

    if (e.key === 'Enter') {
      if (isImport) {
        e.preventDefault();
        e.stopPropagation();
        $target.click();
      } else if (isAddOrder) {
        e.stopPropagation();
        $target.click();
      } else {
        e.preventDefault();
        $('.btn-search-area').click();
      }
    }

    $(document).off('click', '.js-btn-import-order').on('click', '.js-btn-import-order', function (e) {
      e.preventDefault();

      $(".js-input-file-field").trigger("click");
      sessionStorage.setItem('refocusButtonClass', 'js-btn-import-order');
    });

    $('.btn-search-area').on('click keydown', function (e) {
      if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
        sessionStorage.setItem('refocusButtonClass', 'btn-search-area');
      }
    });
  });

  $('#order_item_search input.singledate').each(function () {
    const $input = $(this);

    let lastConfirmedValue = '';
    let justApplied = false;

    $input.on('apply.daterangepicker', function () {
      const drp = $input.data('daterangepicker');

      lastConfirmedValue = $input.val();
      justApplied = true;

      if (drp) {
        drp.hide();

        const originalShow = drp.show;
        setTimeout(() => {
          drp.show = originalShow;
          justApplied = false;
        }, 300);
      }

      setTimeout(() => {
        $input[0].focus();
      }, 100);
    });

    $input.on('focus', function () {
      $input.data('daterangepicker').hide();
    });

    $input.on('input', function () {
      const currentValue = $input.val();
      const drp = $input.data('daterangepicker');

      if (justApplied || currentValue === lastConfirmedValue) {
        return;
      }

      if (drp && !drp.isShowing) {
        drp.show();
      }
    });
  });

  $("#order_item_search").ready(function () {
    var lastFocusedId = $('#last_focused_field').val();
    var $container = $('#order_item_search');
    var $input;

    if (lastFocusedId && $container.find('#' + lastFocusedId).length) {
      $input = $container.find('#' + lastFocusedId);
    } else {
      $input = $container.find('input:first');
    }

    $input.focus();

    var drp = $input.data('daterangepicker');
    if (drp && drp.isShowing) {
      drp.hide();
    }

    if ($input.is('input, textarea')) {
      var val = $input.val();
      $input.val('').val(val);
    }

    const btnClass = sessionStorage.getItem('refocusButtonClass');
    if (!lastFocusedId && btnClass) {
      setTimeout(() => {
        $('.' + btnClass).focus();
      }, 100);
      sessionStorage.removeItem('refocusButtonClass');
    }
  })

  // checkbox in order list
  function getCheckedOrderItemIds() {
    const raw = sessionStorage.getItem("checked_order_item");
    return raw ? raw.split(',').filter(Boolean) : [];
  }

  function saveCheckedOrderItemIds(ids) {
    const uniqueIds = [...new Set(ids)];
    sessionStorage.setItem("checked_order_item", uniqueIds.join(','));
  }

  function resetCheckboxItem(checkedIds) {
    $('input[name=checkbox-order_item]').each(function () {
      const id = $(this).val();
      $(this).prop("checked", false);
      checkedIds = checkedIds.filter(i => i !== id);
      manageLocalStorageOrderItemTypeOfSheet(id, null, 'delete');
    });
    $('input[name=checkbox-order-list][value=check_all]').prop('checked', false);
    sessionStorage.getItem('checked_order_item');
    sessionStorage.setItem('checked_order_item', '');
  }

  $(function () {
    const checkedIds = getCheckedOrderItemIds();
    let allChecked = true;

    $('input[name=checkbox-order_item]').each(function () {
      const id = $(this).val();
      const isChecked = checkedIds.includes(id);
      $(this).prop('checked', isChecked);
      if (!isChecked) allChecked = false;
    });

    $('input[name=checkbox-order-list][value=check_all]').prop('checked', allChecked);
    $('input.js-checked-order_item-ids').val(checkedIds.join(','));
  });

  $(document).on('change', '.js-checkbox-order-list', function () {
    const isCheckAll = $(this).val() === "check_all";
    let checkedIds = getCheckedOrderItemIds();

    if (isCheckAll) {
      if (this.checked) {
        $('input[name=checkbox-order_item]').each(function () {
          const id = $(this).val();
          $(this).prop("checked", true);
          if (!checkedIds.includes(id)) checkedIds.push(id);

          const type_of_sheet = $('.item-row-' + id).find('select#type_of_sheet').val();
          if (type_of_sheet) {
            manageLocalStorageOrderItemTypeOfSheet(id, type_of_sheet, 'update');
          }
        });
      } else {
        resetCheckboxItem(checkedIds);
      }
    } else {
      const id = $(this).val();
      if (this.checked) {
        if (!checkedIds.includes(id)) checkedIds.push(id);
        const type_of_sheet = $('.item-row-' + id).find('select#type_of_sheet').val();
        if (type_of_sheet) {
          manageLocalStorageOrderItemTypeOfSheet(id, type_of_sheet, 'update');
        }
      } else {
        checkedIds = checkedIds.filter(i => i !== id);
        manageLocalStorageOrderItemTypeOfSheet(id, null, 'delete');
      }
    }

    saveCheckedOrderItemIds(checkedIds);
    $('input.js-checked-order_item-ids').val(checkedIds.join(','));
  });

  function getLocalStorageOrderItemTypeOfSheet() {
    const json = sessionStorage.getItem("data_type_of_sheets");
    return json ? JSON.parse(json) : {};
  }

  function manageLocalStorageOrderItemTypeOfSheet(id, type, action) {
    const data = getLocalStorageOrderItemTypeOfSheet();
    if (action === 'update') {
      data[id] = type;
    } else if (action === 'delete') {
      delete data[id];
    }
    sessionStorage.setItem("data_type_of_sheets", JSON.stringify(data));
  }

  // order list per_page
  $(document).on('change', '.js-per-page-select', function () {
    const perPage = $(this).val();
    $('input[name="per_page"]').val(perPage);
    $('.filter-workers-area form').first().submit();
  });

  // cancle order
  $(document).on('change', '.js-checkbox-order_item, .js-checkbox-order-list', function () {
    toggleCancelButton();
    handleCheckAllSync();
  });

  toggleCancelButton();
  function toggleCancelButton() {
    $('.js-btn-cancel-orders').prop('disabled', !(getCheckedOrderItemIds().length > 0));
    $('.js-btn-manufacturing-request').prop('disabled', !(getCheckedOrderItemIds().length > 0));
  }

  function handleCheckAllSync() {
    const allBoxes = $('.js-checkbox-order_item');
    const checkedBoxes = $('.js-checkbox-order_item:checked');
    const isAllChecked = allBoxes.length === checkedBoxes.length;
    $('.js-checkbox-order-list').prop('checked', isAllChecked);
  }

  $(document).on('change', '.js-checkbox-order-list', function () {
    const checked = $(this).is(':checked');
    $('.js-checkbox-order_item').prop('checked', checked);

    if (!checked) {
      sessionStorage.removeItem('checked_order_item');
      sessionStorage.removeItem('data_type_of_sheets');
    }
    toggleCancelButton();
  });

  function syncOrderItemCheckedState(id, isChecked) {
    let checkedIds = getCheckedOrderItemIds();

    if (isChecked) {
      if (!checkedIds.includes(String(id))) checkedIds.push(String(id));

      const type_of_sheet = $('.item-row-' + id).find('select#type_of_sheet').val();
      if (type_of_sheet) {
        manageLocalStorageOrderItemTypeOfSheet(id, type_of_sheet, 'update');
      }
    } else {
      checkedIds = checkedIds.filter(i => i !== String(id));
      manageLocalStorageOrderItemTypeOfSheet(id, null, 'delete');
    }

    saveCheckedOrderItemIds(checkedIds);
    $('.js-checkbox-order_item[value="' + id + '"]').prop('checked', isChecked);
    $('input.js-checked-order_item-ids').val(checkedIds.join(','));

    toggleCancelButton();
    handleCheckAllSync();
  }

  function escapeHtml(str) {
    return $('<div>').text(str || '').html();
  }

  function renderCancelOrderItemsPreview(items) {
    let str = '';
    $.each(items, function (i, item) {
      str += `<div class="row row-item">
                <div class="col-1 d-margin-auto text-center">
                  <input type="checkbox" class="js-cancel-modal-item-checkbox" value="${item.id}" checked>
                </div>
                <div class="col-1 d-margin-auto text-center">${escapeHtml(item.infomart_order_code)}</div>
                <div class="col-2 d-margin-auto">${escapeHtml(item.client_name)}</div>
                <div class="col-3 d-margin-auto">${escapeHtml(item.product_name)}</div>
                <div class="col-2 d-margin-auto text-center">${numberWithCommas(item.amount)} ${escapeHtml(item.unit_type)}</div>
                <div class="col-1 d-margin-auto text-center">${numberWithCommas(item.unit_price)}</div>
                <div class="col-2 d-margin-auto text-center">${escapeHtml(item.delivery_at)}</div>
              </div>`;
    });

    $('.js-cancel-order-items-data').html(str);
  }

  $(document).off('click', '.js-btn-cancel-orders').on('click', '.js-btn-cancel-orders', function () {
    const ids = getCheckedOrderItemIds();

    if (ids.length === 0) return;

    $.ajax({
      url: '/order_items/preview_cancel',
      method: 'GET',
      data: { ids: ids }
    }).done(function (items) {
      renderCancelOrderItemsPreview(items);
      $('#confirm_cancel_modal').modal('show');
    });
  });

  $(document).on('change', '.js-cancel-modal-item-checkbox', function () {
    syncOrderItemCheckedState($(this).val(), $(this).is(':checked'));
  });

  $(document).off('click', '.js-confirm-cancel-ok-btn').on('click', '.js-confirm-cancel-ok-btn', function () {
    const $button = $(this);
    $button.prop('disabled', true);

    const ids = $('.js-cancel-modal-item-checkbox:checked').map(function () {
      return $(this).val();
    }).get();

    if (ids.length === 0) {
      $('#confirm_cancel_modal').modal('hide');
      return;
    }

    $('#confirm_cancel_modal').modal('hide');
    $('.js-destroy-multiple-notify-modal').modal('show');

    $.ajax({
      url: '/order_items/destroy_multiple',
      method: 'DELETE',
      data: { ids: ids },
      success: function () {
        $('.js-destroy-multiple-notify-modal').modal('hide');

        let storedIds = sessionStorage.getItem('checked_order_item') || '';
        let storedIdsArray = storedIds.split(',').filter(id => id.trim() !== '');
        const remainingIds = storedIdsArray.filter(id => !ids.includes(id));
        sessionStorage.setItem('checked_order_item', remainingIds.join(','));

        const sheetData = JSON.parse(sessionStorage.getItem('data_type_of_sheets') || '{}');
        ids.forEach(id => delete sheetData[id]);
        sessionStorage.setItem('data_type_of_sheets', JSON.stringify(sheetData));

        sessionStorage.setItem(SCROLL_TOP_AFTER_RELOAD_KEY, '1');

        const url = new URL(window.location.href);

        if (url.searchParams.has('page')) {
          url.searchParams.delete('page');
          window.location.href = url.toString();
        } else {
          location.reload();
        }
        toggleCancelButton();
      },
      error: function (jqXHR, textStatus, errorThrown) {
        $('.js-destroy-multiple-notify-modal').modal('hide');
        $button.prop('disabled', false);

        console.error('destroy_multiple failed:', textStatus, errorThrown, jqXHR.status);

        let message = '削除に失敗しました。もう一度お試しください。';
        if (jqXHR.status === 0) {
          message = 'ネットワークエラーが発生しました。接続をご確認ください。';
        } else if (textStatus === 'timeout') {
          message = '処理に時間がかかっています。しばらくしてから再度お試しください。';
        } else if (jqXHR.status === 422 || jqXHR.status === 401) {
          message = 'セッションが切れた可能性があります。ページを再読み込みしてください。';
        }

        showDestroyMultipleError(message);
      },
    });
  });

  function showDestroyMultipleError(message) {
    alert(message);
  }  

  $(document).off('click', '.js-btn-manufacturing-request').on('click', '.js-btn-manufacturing-request', function (e) {
    e.preventDefault();

    const rawIds = sessionStorage.getItem('checked_order_item');
    if (!rawIds) return;

    const ids = rawIds.split(',').map(id => id.trim()).filter(id => id !== '');
    if (ids.length === 0) return;
    $.ajax({
      url: '/stock/products/batch_new_order_producing',
      method: 'GET',
      data: {
        order_item_ids: ids,
        authenticity_token: $('meta[name="csrf-token"]').attr('content')
      }
    });
  });

  $(document).off("hidden.bs.modal").on('hidden.bs.modal', '#js-order-list-producing-modal, #confirm_cancel_modal', function () {
    cleanupModals();
  });

  function cleanupModals() {
    $('#js-order-list-producing-modal').modal('hide');
    sessionStorage.removeItem('checked_order_item');
    sessionStorage.removeItem('data_type_of_sheets');

    let checkedIds = getCheckedOrderItemIds();
    resetCheckboxItem(checkedIds);
    toggleCancelButton();

    setTimeout(() => {
      document.querySelectorAll("#js-order-list-producing-modal").forEach(modal => modal.remove());

      if ($('.modal.show').length === 0) {
        document.querySelectorAll(".modal-backdrop").forEach(b => b.remove());
        document.body.classList.remove("modal-open");
      }
    }, 300);
  }

  function handleSelectDirectiveTypeProduceOrders($dropdownParent) {
    $dropdownParent.find('.js-select-directive-type').each(function () {
      const $select = $(this);
      const index = $select.data('index');

      if ($select.hasClass("select2-hidden-accessible")) return;

      $select.select2({
        dropdownParent: $dropdownParent,
        language: {
          noResults: function () {
            return "見つかりません";
          }
        },
        width: '100%'
      });

      $select.off('select2:select').on('select2:select', function (e) {
        let data = e.params.data;
        let $unitElem = $dropdownParent.find(`.js-unit-type-col[data-index="${index}"]`);

        if (data.id === 'directive_product') {
          $unitElem.text('個');
        } else if (data.id === 'directive_dough') {
          $unitElem.text('本');
        } else if (data.id === 'directive_remain_dough') {
          $unitElem.text('キロ');
        }
      });
    });
  }

  $(document).on('shown.bs.modal', '#js-order-list-producing-modal', function () {
    handleSelectDirectiveTypeProduceOrders($(this));
  });

  const $rows = $('.order-items-list .row-content .row');
  let lastCheckedIndex = null;

  $rows.each(function (index) {
    $(this).on('click', function (e) {
      let itemCheckedIds = (sessionStorage.getItem('checked_order_item') || '')
          .split(',')
          .filter(Boolean)
          .map(id => parseInt(id, 10));

      if ($(e.target).is('input[type="checkbox"], select')) return;

      const $checkbox = $(this).find('input.js-checkbox-order_item');
      if ($checkbox.length === 0) return;
      const isCurrentlyChecked = $checkbox.prop('checked');
      $checkbox.prop('checked', !isCurrentlyChecked)[0].click();
      const id = $checkbox.val();

      if (e.shiftKey && lastCheckedIndex !== null) {
        const start = Math.min(index, lastCheckedIndex);
        const end = Math.max(index, lastCheckedIndex);
        const shouldCheck = !isCurrentlyChecked;

        for (let i = start; i <= end; i++) {
          const $cb = $rows.eq(i).find('input.js-checkbox-order_item');
          if ($cb.length) {
            const idCb = $cb.val();
            $cb.prop('checked', shouldCheck);

            if (shouldCheck) {
              if (!itemCheckedIds.includes(idCb)) itemCheckedIds.push(idCb);

              let data = JSON.parse(sessionStorage.getItem('data_type_of_sheets')) || {};
              data[idCb] = "slip_document";
              sessionStorage.setItem('data_type_of_sheets', JSON.stringify(data));
            } else {
              itemCheckedIds = itemCheckedIds.filter(val => val !== idCb);
              let checkedOrderItems = sessionStorage.getItem('checked_order_item');
              checkedOrderItems = itemCheckedIds.filter(id => id !== idCb);

              const sheetData = JSON.parse(sessionStorage.getItem('data_type_of_sheets') || '{}');
              delete sheetData[idCb];
              sessionStorage.setItem('data_type_of_sheets', JSON.stringify(sheetData));
            }
          }
        }
      } else {
        const newChecked = !isCurrentlyChecked;
        $checkbox.prop('checked', newChecked);

        if (newChecked) {
          if (!itemCheckedIds.includes(id)) itemCheckedIds.push(id);

          let data = JSON.parse(sessionStorage.getItem('data_type_of_sheets')) || {};
          data[id] = "slip_document";
          sessionStorage.setItem('data_type_of_sheets', JSON.stringify(data));
        } else {
          const sheetData = JSON.parse(sessionStorage.getItem('data_type_of_sheets') || '{}');
          delete sheetData[id];
          sessionStorage.setItem('data_type_of_sheets', JSON.stringify(sheetData));
        }
      }

      const dataSheets = JSON.parse(sessionStorage.getItem('data_type_of_sheets') || '{}');
      sessionStorage.setItem('checked_order_item', Object.keys(dataSheets).join(','));

      toggleCancelButton();
      lastCheckedIndex = index;
    });
  });

  // Edit order item modal
  $(document).on('click', '.js-btn-edit-order-item', function(e) {
    e.preventDefault();
    
    const $btn = $(this);
    const itemId = $btn.data('item-id');
    const productName = $btn.data('product-name');
    const amount = $btn.data('amount');
    const unitType = $btn.data('unit-type');
    
    // Set values in modal
    $('#edit-order-item-id').val(itemId);
    $('#edit-order-item-product-name').val(productName);
    
    // Format the amount with commas
    const formattedAmount = numberWithCommas(amount);
    $('#edit-order-item-amount').val(formattedAmount);
    $('#edit-order-item-unit').text(unitType);
    
    // Show modal
    $('#edit_order_item_modal').modal('show');
  });

  $(document).on('click', '.js-save-order-item', function(e) {
    e.preventDefault();
    
    const itemId = $('#edit-order-item-id').val();
    const amountRaw = $('#edit-order-item-amount').val();
    
    // Parse formatted number (remove commas)
    const amount = parseFormattedNumber(amountRaw);
    
    if (!amountRaw || amount <= 0) {
      alert('数量を入力してください。');
      return;
    }
    
    // Disable save button to prevent double click
    const $saveBtn = $(this);
    $saveBtn.prop('disabled', true);
    
    $.ajax({
      url: '/order_items/update_status',
      method: 'POST',
      dataType: 'json',
      data: {
        id: itemId,
        order_item: {
          amount: amount
        },
        authenticity_token: $('meta[name="csrf-token"]').attr('content')
      },
      success: function(response) {
        // Close modal
        $('#edit_order_item_modal').modal('hide');
        
        // Reload the page to show updated data
        location.reload();
      },
      error: function(xhr, status, error) {
        alert('更新に失敗しました。');
        $saveBtn.prop('disabled', false);
      }
    });
  });

  // Reset modal when it's closed
  $('#edit_order_item_modal').on('hidden.bs.modal', function() {
    $('#edit-order-item-id').val('');
    $('#edit-order-item-product-name').val('');
    $('#edit-order-item-amount').val('');
    $('#edit-order-item-unit').text('');
    $('.js-save-order-item').prop('disabled', false);
  });
});
